import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material'
import { analyticsManager } from '../../../../../../sharedComponents/src/globalHeader/services/analytics/AnalyticsManager'

interface IScoreRow {
    leftScore: number
    rightScore: number
    title: string
    isMain?: boolean
}

const ScoreRow: React.FC<IScoreRow> = ({ leftScore, rightScore, title, isMain }) => (
    <Stack direction="row" sx={{ flexGrow: 1, justifyContent: 'center' }}>
        <Typography variant={isMain ? 'h5' : 'body2'} sx={{ flexBasis: '30%', textAlign: 'center' }}>
            {leftScore}
        </Typography>
        <Typography
            variant={isMain ? 'h5' : 'body2'}
            textTransform={isMain ? 'uppercase' : 'capitalize'}
            sx={{ flexBasis: '30%', textAlign: 'center' }}
        >
            {title}
        </Typography>
        <Typography variant={isMain ? 'h5' : 'body2'} sx={{ flexBasis: '30%', textAlign: 'center' }}>
            {rightScore}
        </Typography>
    </Stack>
)

interface IProps {
    whiteWins: number
    blackWins: number
    draws: number
    observer: boolean
}

const ResultColumn: React.FC<IProps> = ({ whiteWins, blackWins, draws, observer }) => {
    const mainScoreLeft = whiteWins + draws * 0.5
    const mainScoreRight = blackWins + draws * 0.5

    const handleExpandedChange = () => {
        analyticsManager.dispatchEvent('gameButtonPressed', {
            eventLocation: observer ? 'watchSummaryDialogue' : 'gameSummaryDialogue',
            buttonIndex: 5,
        })
    }

    return (
        <Accordion sx={{ dislay: 'flex', flexGrow: '1' }} onChange={handleExpandedChange}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                    minHeight: 0,
                    pl: 5,
                    '& .MuiAccordionSummary-content': {
                        m: 0,
                    },
                    '&.Mui-expanded': {
                        minHeight: 0,
                    },
                }}
            >
                <ScoreRow leftScore={mainScoreLeft} rightScore={mainScoreRight} title="score" isMain />
            </AccordionSummary>
            <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: '12px', pb: 0, pt: '12px', px: 5 }}>
                {(whiteWins > 0 || blackWins > 0) && (
                    <ScoreRow leftScore={whiteWins} rightScore={blackWins} title="wins" />
                )}
                {(blackWins > 0 || whiteWins > 0) && (
                    <ScoreRow leftScore={blackWins} rightScore={whiteWins} title="losses" />
                )}
                {draws > 0 && <ScoreRow leftScore={draws} rightScore={draws} title="draws" />}
            </AccordionDetails>
        </Accordion>
    )
}

export default ResultColumn
